// extracted by mini-css-extract-plugin
export default {"box":"Range_box__JRe5x"};